import { getDataAll } from '../utils/dataUtils';
import { insertHtmlWithScripts } from '../utils/domUtils';
import { SendData } from '../utils/SendData'; // Предполагается, что есть модуль SendData
import { COMPONENT_TYPE } from '../constants';

export class DynamicElementManager {
  constructor({ elem, url = '', data = {}, headers = {}, firstLoad = true, sendFormDataOnRelaod = false }) {
    this.firstLoad = firstLoad; // Флаг для первого загрузки
    this._sendFormDataOnRelaod = sendFormDataOnRelaod; // Флаг для отправки данных формы при перезагрузке
    this.container = elem;
    this.url = url || elem.dataset.url || ''; // Берём URL из параметра или data-url
    this._headers = headers; // Используем переданные заголовки
    this.fieldset = elem.querySelector('fieldset'); // Ищем fieldset внутри контейнера
    if (!this.fieldset) {
      this.fieldset = elem.closest('fieldset');
    }
    if (!this.url) {
      console.warn('DynamicElementManager: URL не найден (ни в параметрах, ни в data-url):', elem);
      return;
    }
    this.urlPath = new URL(this.url, window.location.origin).pathname; // Извлекаем путь из URL
    // Сохраняем экземпляр в самом элементе
    this.container.dynamicElementManagerInstance = this;
    this.container.reloader = this.reload.bind(this);
    this.data = Object.assign(
      {},
      data, // Используем переданные данные
      getDataAll(this.container), // Получаем все данные из контейнера
    );
    // Инициализируем загрузку
    this._init();
  }

  async _init() {
    if (this.firstLoad) {
      this.container.classList.add('loading'); // Добавляем класс загрузки
      this.loadElement();
    }
  }

  loadElement({ data = {}, reload = false } = {}) {
    if (reload)
      this._headers.Reload = 'true';
    if (reload && this._sendFormDataOnRelaod) {
      Object.assign(this.data, this.fieldset.data);
    }
    return new SendData({
      data: Object.assign({}, this.data, data),
      url: this.url,
      headers: Object.assign({ [COMPONENT_TYPE]: 'dynamic-element' }, this._headers),
    }).then((response) => {
      while (this.container.firstChild) {
        this.container.removeChild(this.container.firstChild);
      }
      insertHtmlWithScripts({
        html: response.answer,
        parent: this.container
      });
      this.fieldset = this.container.querySelector('fieldset');
      const autoFocusElement = this.container.querySelector('[autofocus="true"]');
      if (autoFocusElement) {
        autoFocusElement.focus();
      }
    });
  }

  // Метод для перезагрузки элемента
  reload({ data = {}, reload = true } = {}) {
    return this.loadElement({ data, reload });
  }
}
